module.exports = __webpack_public_path__ + "static/img/popup.d2b30cd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/popup.jpg
// module id = /C4y
// module chunks = 1